export default __webpack_public_path__ + "static/media/logo-v3.9ac1ccf3.png";